import Service from '@ember/service';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import config from '@linc-technologies/linced-common/utils/config';

export default class HeroApiBookingsAllocationsService extends Service {
  @service
  fetch;

  @service
  store;

  reserve(id) {
    return this._statusAction(id, 'reserve');
  }

  block(id) {
    return this._statusAction(id, 'block');
  }

  release(id) {
    return this._statusAction(id, 'release');
  }

  _statusAction(id, action) {
    return this.fetch
      .post(`${config.APP.apiHost}/bookings/v4/allocations/${id}/:${action}`)
      .then((response) => {
        if (!isEmpty(response.allocation)) {
          this.store.pushPayload('bookings/allocation', response);
        }
        return Promise.resolve();
      });
  }
}
